export default __webpack_public_path__ + "static/media/payoutFooterImg.b9b7a6da.png";